import React, { useState } from "react";
import styles from "./ProfileMobileNav.module.css";

const navLinks = {
  회원정보: [
    { label: "회원정보 수정", value: "confirmPassword" },
    { label: "회원탈퇴", value: "withdrawal" },
  ],
  고객센터: [
    { label: "모의 견적 내역", value: "consultationHistory" },
    { label: "출간 내역", value: "newConsultation" },
  ],
};

const findLabelByValue = (value) => {
  for (const category in navLinks) {
    const found = navLinks[category].find((item) => item.value === value);
    if (found) return found.label;
  }
  return "마이페이지";
};

const ProfileMobileNav = ({ activePage, setActivePage }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (pageValue) => {
    setActivePage(pageValue);
    setIsOpen(false);
  };

  const activeLabel = findLabelByValue(activePage);

  return (
    <div className={styles.mobileNavWrapper}>
      <button
        className={styles.dropdownToggle}
        onClick={() => setIsOpen(!isOpen)}
      >
        {activeLabel}
        <span className={`${styles.arrow} ${isOpen ? styles.open : ""}`}></span>
      </button>
      {isOpen && (
        <div className={styles.dropdownMenu}>
          {Object.entries(navLinks).map(([category, items]) => (
            <div key={category} className={styles.categoryGroup}>
              <div className={styles.categoryTitle}>{category}</div>
              {items.map((item) => (
                <button
                  key={item.value}
                  onClick={() => handleSelect(item.value)}
                  className={`${styles.dropdownItem} ${
                    activePage === item.value ? styles.active : ""
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProfileMobileNav;
